import type { ReadonlyURL } from "$app/state";
import { UNREACHABLE } from "@colossus/api-client";
import type { ApiResult } from "@colossus/api-client";

export const attempt = async <T, C extends string = string>(
  call: Promise<ApiResult<T, C>>,
): Promise<ApiResult<T, C>> => {
  try {
    return await call;
  } catch {
    return { ok: false, status: UNREACHABLE, code: null, body: null, retryAfterSeconds: null };
  }
};

export const okOr = async <T, F>(call: Promise<ApiResult<T>>, fallback: F): Promise<T | F> => {
  const result = await attempt(call);
  return result.ok ? result.data : fallback;
};

export const ACCOUNTS_PAGE_SIZE = 25;

export const AUDIT_PAGE_SIZE = 50;

export const SHOWCASE_PAGE_SIZE = 50;

export const UNFILTERED = "";

export const FIRST_PAGE = 0;

export const filterTerm = (url: ReadonlyURL, key: string): string => {
  const raw = url.searchParams.get(key);
  return raw === null ? UNFILTERED : raw;
};

export const pageOffset = (url: ReadonlyURL): number => {
  const raw = url.searchParams.get("offset");
  if (raw === null) return FIRST_PAGE;
  const parsed = Number(raw);
  return Number.isInteger(parsed) && parsed >= FIRST_PAGE ? parsed : FIRST_PAGE;
};
